import Field from 'src/components/Common/InputContainer'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Turnstile from 'react-turnstile'

interface StepOneProps {
  onTurnstileVerify: (token: string) => void
  onTurnstileError: () => void
  onTurnstileExpire: () => void
}

const StepOne: React.FC<StepOneProps> = ({
  onTurnstileVerify,
  onTurnstileError,
  onTurnstileExpire,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="step-header">
        <h1>{t('forgot.stepOne.title')}</h1>
        <p>{t('forgot.stepOne.desc')}</p>
      </div>
      <Field
        required
        name="email"
        component="input"
        preset="primary"
        label={t('login.form.email')}
      />
      <Turnstile
        sitekey={process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY || ''}
        onVerify={onTurnstileVerify}
        onError={onTurnstileError}
        onExpire={onTurnstileExpire}
        theme="light"
        size="flexible"
      />
    </>
  )
}

export default StepOne
